module.exports = __webpack_public_path__ + "img/7.055f0efb.png";